let Axios = require('axios-https-proxy-fix')
const _ = require('underscore')
const Promise = require('bluebird')
const useragentFromSeed = require('useragent-from-seed')

const getProfileDataDirect = async (username) => {

  let dataExp = /window\._sharedData\s?=\s?({.+);<\/script>/;

  const agentList = ['Mozilla/5.0 (Linux; Android 6.0.1; SM-G935S Build/MMB29K; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/55.0.2883.91 Mobile Safari/537.36', 'Mozilla/5.0 (iPhone; CPU iPhone OS 12_0 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/12.0 Mobile/15E148 Safari/604.1', 'Mozilla/5.0 (iPhone; CPU iPhone OS 12_0 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) CriOS/69.0.3497.105 Mobile/15E148 Safari/605.1', 'Mozilla/5.0 (iPhone; CPU iPhone OS 12_0 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) FxiOS/13.2b11866 Mobile/16A366 Safari/605.1.15', 'Mozilla/5.0 (iPhone; CPU iPhone OS 11_0 like Mac OS X) AppleWebKit/604.1.38 (KHTML, like Gecko) Version/11.0 Mobile/15A372 Safari/604.1', 'Mozilla/5.0 (iPhone; CPU iPhone OS 11_0 like Mac OS X) AppleWebKit/604.1.34 (KHTML, like Gecko) Version/11.0 Mobile/15A5341f Safari/604.1', 'Mozilla/5.0 (iPhone; CPU iPhone OS 11_0 like Mac OS X) AppleWebKit/604.1.38 (KHTML, like Gecko) Version/11.0 Mobile/15A5370a Safari/604.1', 'Mozilla/5.0 (iPhone9,3; U; CPU iPhone OS 10_0_1 like Mac OS X) AppleWebKit/602.1.50 (KHTML, like Gecko) Version/10.0 Mobile/14A403 Safari/602.1', 'Mozilla/5.0 (iPhone9,4; U; CPU iPhone OS 10_0_1 like Mac OS X) AppleWebKit/602.1.50 (KHTML, like Gecko) Version/10.0 Mobile/14A403 Safari/602.1', 'Mozilla/5.0 (Apple-iPhone7C2/1202.466; U; CPU like Mac OS X; en) AppleWebKit/420+ (KHTML, like Gecko) Version/3.0 Mobile/1A543 Safari/419.3', 'Mozilla/5.0 (Linux; Android 7.0; Pixel C Build/NRD90M; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/52.0.2743.98 Safari/537.36', 'Mozilla/5.0 (Linux; Android 6.0.1; SGP771 Build/32.2.A.0.253; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/52.0.2743.98 Safari/537.36', 'Mozilla/5.0 (Linux; Android 6.0.1; SHIELD Tablet K1 Build/MRA58K; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/55.0.2883.91 Safari/537.36', 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/42.0.2311.135 Safari/537.36 Edge/12.246', 'Mozilla/5.0 (X11; CrOS x86_64 8172.45.0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/51.0.2704.64 Safari/537.36', 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_11_2) AppleWebKit/601.3.9 (KHTML, like Gecko) Version/9.0.2 Safari/601.3.9', 'Mozilla/5.0 (Windows NT 6.1; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/47.0.2526.111 Safari/537.36']



  let baseUrl = 'https://instagram.com'
  let setHeaders = {

    'Accept-Language': 'en',
   
    'X-Requested-With': 'XMLHttpRequest',

    Referer: baseUrl
  }
  setHeaders['User-Agent'] = await useragentFromSeed(username)
  setHeaders['Content-Type'] = 'application/x-www-form-urlencoded'
  

  try {
    const proxy = [{
      host: '35.222.168.81',
      port: '3128',
      auth: {
        username: 'ts_rotating',
        password: 'tapspree20'
      }
    }]

    //http://ts_proxy:tapspree20@35.222.168.81:3128

    const finalProxy = _.shuffle(proxy)[0];

    //console.log("HERE IS THE FINAL PROXY:", finalProxy)


    let profileCheck = await Axios.get(`https://www.instagram.com/${username}`,  setHeaders)

    profileCheck = profileCheck.data


    let dataString = profileCheck.match(dataExp)[1];

    let profileRaw = JSON.parse(dataString);

    //console.log("HERE IS THE BODY: ", JSON.stringify(profileRaw.entry_data.ProfilePage[0].graphql))

    if (typeof profileRaw.entry_data.ProfilePage[0].graphql != 'undefined') {
      let profileData = profileRaw.entry_data.ProfilePage[0]

      //console.log("ADDING THIS PROFILE PIC: ", profileData.graphql.user.profile_pic_url_hd )

      let thisProfile = {}
      thisProfile.profileName = profileData.graphql.user.username
      thisProfile.id = profileData.graphql.user.id
      thisProfile.followerCount = profileData.graphql.user.edge_followed_by.count
      thisProfile.followingCount = profileData.graphql.user.edge_follow.count
      thisProfile.postCount = profileData.graphql.user.edge_owner_to_timeline_media.count
      thisProfile.profilePic = profileData.graphql.user.profile_pic_url_hd
      thisProfile.isPrivate = profileData.graphql.user.is_private
      thisProfile.biography = profileData.graphql.user.biography
      thisProfile.website = profileData.graphql.user.external_url
      thisProfile.fullName = profileData.graphql.user.full_name

      let postList = profileData.graphql.user.edge_owner_to_timeline_media.edges

      if (postList.length > 0) {


        //console.log("HERE IS THE POST LIST: ", postList)


        postList = await Promise.map(postList, (x) => {
          return (async () => {
            try {

              let postInfo = {}
              postInfo.postId = x.node.id
              postInfo.caption = x.node.edge_media_to_caption.edges[0].node.text
              postInfo.shortcode = x.node.shortcode
              postInfo.isVideo = x.node.is_video
              postInfo.thumbnails = x.node.thumbnail_resources
              postInfo.likeCount = x.node.edge_liked_by.count
              postInfo.commentCount = x.node.edge_media_to_comment.count
              postInfo.displayUrl = x.node.display_url
              postInfo.date = x.node.taken_at_timestamp

              if (x.node.is_video === true) {

                try {

                  //postInfo.videoUrl = x.node.videoUrl
                  postInfo.viewCount = x.node.video_view_count

                } catch (e) {
                  //console.log("THERE WAS AN ERROR: ", e)
                  return []
                }


              }
              return postInfo
            } catch (e) {
              return []
            }
          })()

        })
      }


      thisProfile.postList = _.flatten(postList)
      let profileResponse = {}
      profileResponse.success = true
      profileResponse.result = thisProfile

      //console.log("HERE IS THE PROFILE WE GOT: ", thisProfile)

      return profileResponse

    } else {
      return {
        success: false,
        message: "Could not load the profile"
      }
    }

  } catch (e) {
    //console.log("THERE WAS AN ERROR: ", e)
    if (process.env.NODE_ENV != 'production') {
      //console.error('The HTML returned from instagram was not suitable for scraping');
      return {
        success: false
      }
    }
    return {
      success: false
    }
  }

}


module.exports = {
  getProfileDataDirect
};